var _excluded = ["className", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import "./ASpinLoader.scss";
var baseClass = "a-spin-loader";
var ASpinLoader = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var propsClassName = _ref.className,
    size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = baseClass,
    spinnerClasslassName = "".concat(baseClass, "__spinner");
  switch (size) {
    case "small":
      {
        className += " ".concat(baseClass, "--size-small");
        break;
      }
    case "large":
      {
        className += " ".concat(baseClass, "--size-large");
        break;
      }
    default:
      {
        className += " ".concat(baseClass, "--size-medium");
      }
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className
  }, rest), /*#__PURE__*/React.createElement("div", {
    role: "progressbar",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    ref: ref,
    className: spinnerClasslassName
  }));
});
ASpinLoader.propTypes = {
  /**
   * Sets the size of the indicator.
   */
  size: PropTypes.oneOf(["small", "medium", "large"])
};
ASpinLoader.displayName = "ASpinLoader";
export default ASpinLoader;